import css from 'styled-jsx/css';

const SizeChartTableStyles = css`
  .size-chart-table-container {
    padding: 20px;
    width: 100%;
    max-width: 100%;
    cursor: default;
  }

  .size-chart-tabs {
    display: flex;
    position: relative;
    gap: 0;
    max-width: 760px;
    margin: 0 auto 20px auto;
    border-radius: 18px;
    overflow: hidden;
    padding: 4px;
    background-color: #ebebeb;
  }

  input[type='radio'] {
    display: none;
  }

  .tab-button {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background-color: transparent;
    border: none;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    cursor: pointer;
    transition: color 0.25s ease-out;
    border-radius: 16px;
    z-index: 2;
    position: relative;
  }

  .tab-button:has(input[type='radio']:checked) {
    color: #333;
    font-weight: 600;
  }

  .tab-button:hover {
    color: #333;
  }

  .glider {
    position: absolute;
    display: flex;
    height: calc(100% - 8px);
    width: calc(50% - 4px);
    background-color: #fff;
    z-index: 1;
    border-radius: 16px;
    transition: transform 0.25s ease-out;
    left: 4px;
    top: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .tab-button:has(input[id='tab-table']:checked) ~ .glider {
    transform: translateX(0);
  }

  .tab-button:has(input[id='tab-how-to']:checked) ~ .glider {
    transform: translateX(100%);
  }

  .size-chart-grid {
    display: grid;
    max-width: 760px;
    margin: 0 auto 20px;
    gap: 0;
    border-radius: 4px;
    overflow: hidden;
    font-size: 14px;
  }

  .grid-header {
    background-color: #dddddd;
    padding: 10px 12px;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .grid-cell {
    padding: 10px 12px;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    color: #333;
  }

  .grid-cell.even-row {
    background-color: #f9f9f9;
  }

  .grid-cell.odd-row {
    background-color: #fff;
  }

  .grid-cell.last-column {
    border-right: none;
  }

  .grid-header.active-column,
  .grid-cell.active-column {
    font-weight: 600;
  }

  .size-chart-help-text {
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    text-align: left;
    margin: 20px 0;
    padding: 0 20px;
    max-width: 760px;
    margin-left: auto;
    margin-right: auto;
  }

  .help-text-intro {
    font-weight: bold;
    margin: 0 0 12px 0;
    color: #333333;
    font-size: 12px;
  }

  .help-text-title {
    font-weight: bold;
    margin-bottom: 8px;
    margin-top: 0;
    color: #333333;
  }

  .help-text-detail {
    font-weight: normal;
    margin: 0;
    color: #333333;
  }

  @media (max-width: 768px) {
    .size-chart-table-container {
      padding: 12px;
    }

    .size-chart-tabs {
      margin-bottom: 12px;
    }

    .tab-button {
      padding: 8px 16px;
      font-size: 14px;
    }

    .grid-header {
      padding: 12px 8px;
      font-size: 14px;
    }

    .grid-cell {
      padding: 8px 8px;
      font-size: 14px;
    }

    .size-chart-help-text {
      font-size: 14px;
      padding: 0 12px;
    }
  }

  @media (max-width: 480px) {
    .grid-header {
      padding: 10px 4px;
      font-size: 12px;
    }

    .grid-cell {
      padding: 8px 4px;
      font-size: 12px;
    }
  }

  @media (max-width: 380px) {
    .grid-header {
      padding: 8px 2px;
      font-size: 11px;
    }

    .grid-cell {
      padding: 8px 2px;
      font-size: 10px;
    }
  }
  .underlined-satisfaction {
    text-decoration: underline;
  }
`;

export { SizeChartTableStyles };
